export default {
  "StatusIcon": "_StatusIcon_1w8fn_1"
};import "ni:sha-256;KCMjBD-rWrKYzYsjDLjSNQbIMKB1eEYxKv875SndGPA";